// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"ac352582","453":"696006ab","638":"db788095"}[chunkId] + ".chunk.js";
};